import React, { useEffect, useState, useCallback } from 'react'
import './OduLandingPage.scss'
import PlanTable from '../PlanTable/PlanTable';
import DynamicForm from '../DynamicForm';
import { geoCode, getFormSchema, getCityData } from '../service';
import { getBundles, getLineType, getOtpV1, submitLead } from '../../../orp/shared/service';
import { useLoading } from '../../../../Shared/cache/context/LoadingProvider';
import AwOtpModal from '../AwOtpModal';
import Modal from '../../../../Shared/Components/Modal';
import { useNavigate } from 'react-router-dom';
import MapPicker from '../MapPicker';
import ToastMsg from '../../../orp/shared/components/ToastMsg/ToastMsg';
import { eventEmitter } from '../../../../Shared/service/google-analytics.service';
import { AW_TRANSANCTION_TYPE, AW_TRANSANCTION_TYPE_SW, FORM_SCHEMA, INSTALLATION, PREPAID, SERVICE_TYPE, WEBPORTAL, WEBSITE, AIRTEL_WORKS, EN } from '../../constant/constant';
import useFetch from "../../../../Shared/cache/useFetch";
import { useLanguage } from "../../../../Shared/cache/context/LanguageProvider";
import { TRANSLATION, GET, ORP_TRANSLATION, LANGUAGE_PREFIX } from "../../../../Shared/helper/constants";
import { GA } from '../../../orp/helper/constants';
import { getSessionData } from '../../../../Shared/helper/storage';
import { safeJsonParse } from '../../../../Shared/utils/commonutils';
import { generateMsisdn } from '../../../../Shared/helper/helper';
import useResponsive from '../../../../FTTX/hooks/useResponsive';
import HbbPlanList from './Components/HbbPlanList';

const OduLandingPage = ({ deviceDetails }) => {

  const [bundleData, setBundleData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [isServiceable, setIsServiceable] = useState(false);
  const [hideServiceModal, setHideServiceModal] = useState(false);
  const [coordinates, setCoordinates] = useState({});
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isAirtelNumber, setIsAirtelNumber] = useState(false);
  const [refId, setRefId] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [formSchema, setFormSchema] = useState({});
  const [showMap, setShowMap] = useState(false);
  const [bundles, setBundles] = useState([]);
  const [towns, setTowns] = useState([]);
  const [clearFormData, setClearFormData] = useState(false)
  const [isOtpLimitExhausted, setisOtpLimitExhausted] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');

  const { isMobileDevice } = useResponsive()
  const { showLoader, hideLoader } = useLoading();
  const navigate = useNavigate();
  const [translation, setTranslation] = useState({
    selectPlanText: "Select a 5G plan to continue",
    selectedPlanDescription: "Choose any of the monthly plans and enjoy your world of speed. 1TB FUP applies.",
    noteText: "The Pricing above includes taxes and one time connection fee of N20,000.",
    note: "Note-",
    customerDetails: "Customer Details",
    back: "Back",
    proceed: "Proceed",
    congratulations: "Congratulations!",
    serviceAvailableText: "Service is available in your area!",
    redirectMsg: "Redirecting you to the payment page shortly.",
    thankYou: "Thank you!",
    serviceUnavailableText: " For your interest in our 5G Outdoor Unit SmartConnect service. While the service is not yet available in your location,we have high-speed 4G routers and other reliable connectivity devices that might suit your needs. Redirecting you to the home page shortly.",
    exploreProduct: "Explore other Products",
    bundleTable: {
      bundles: "Bundles",
      resources: "Resources",
      bundleValidity: "Bundle Validity",
      price: "Price",
      select: "Select",
      speed: "Speed",
      validity: "Validity"
    },
    dynamicForm: {
      isRequired: " is required",
      mustBeAtLeast: " must be at least",
      characters: "characters",
      validText: "Please enter a valid",
      address: " address",
      landmark: " landmark",
      invalid: "Invalid",
      mustBeMore: "must be no more than",
      customDropdown: {
        search: "Search",
        noMatch: "No match"
      }
    }
  });
  const { languagePrefix, selectedLanguage } = useLanguage();
  const { data: data, refetch } = useFetch({
    url: ORP_TRANSLATION.replace(LANGUAGE_PREFIX, languagePrefix),
    method: GET,
    key: TRANSLATION,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });
  useEffect(() => {
    if (data?.awlanding) setTranslation({ ...translation, ...data?.awlanding })
  }, [data])

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
      refetch(true);
    } else {
      refetch(false)
    }
  }, [selectedLanguage]);
  useEffect(() => {
    fetchBundles();
    let redirectUrl = sessionStorage.getItem('redirect_url');
    setRedirectUrl(redirectUrl);
    eventEmitter(AIRTEL_WORKS, 'hbb_5g_plan_selection_page_loaded', 'page load', 'hbb_5g_plan_selection_page_loaded', null);
  }, [])


  useEffect(() => {
    fetchFormSchema()
  }, [selectedLanguage]);

  const fetchBundles = () => {
    let postRequest = {
      data: { "serviceType": SERVICE_TYPE },
    };
    showLoader();
    getBundles(postRequest).then(res => {
      if (res?.data?.statusCode == 200) {
        setBundles(res?.data?.result);
        eventEmitter(AIRTEL_WORKS, 'te_fetch_bundle_success', 'click', 'te_fetch_bundle_success', null);
      }
      else {
        showToastMsg(
          "Error",
          res?.error?.message || res?.message || "Something Went Wrong!"
        );
        eventEmitter(AIRTEL_WORKS, 'te_fetch_bundle_failed', 'click', res?.error?.message || res?.message, null);
      }
      hideLoader();
    })
      .catch((error) => {
        hideLoader();
        showToastMsg(
          "Error",
          error?.error?.message || error?.message || "Something Went Wrong!"
        );
        eventEmitter(AIRTEL_WORKS, 'te_fetch_bundle_failed', 'click', error?.error?.message || error?.message, null);
      });
  }

  const fetchFormSchema = () => {
    let url = FORM_SCHEMA.replace(LANGUAGE_PREFIX, languagePrefix)
    getFormSchema(url).then(resp => {
      setFormSchema(safeJsonParse(resp?.data?.packageHtml));
      fetchTownList(safeJsonParse(resp?.data?.packageHtml));
      eventEmitter(AIRTEL_WORKS, 'te_fetch_form_fields_success', 'click', '', null);
    })
  }

  const fetchTownList = (data) => {
    getCityData().then(res => {
      let towns = res?.data?.result?.data || [];
      setTowns(towns)
      let schema = { ...data };
      schema = {
        ...schema,
        fields: schema?.fields?.map((field) =>
          field.type === 'select' && field.name === 'town'
            ? { ...field, options: towns?.map((town) => ({ value: town?.cityName, label: town?.cityName })) }
            : field
        ),
      };

      setFormSchema(schema);
      eventEmitter(AIRTEL_WORKS, 'te_fetch_town_list_success', 'click', 'te_fetch_town_list_success', null);
    });
  };

  const fetchCoordinates = (address, landmark, town) => {
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder();

      if (!geocoder) {
        setShowMap(true);
        return resolve(null);
      }

      geocoder.geocode(
        { address: `${address},${landmark},${town}` },
        (results, status) => {
          const locationObj = results[0]?.geometry?.location;
          const location = {
            lat: locationObj.lat(),
            lng: locationObj.lng(),
          };
          if (status === "OK" && location?.lat && location?.lng) {
            resolve(location);
          } else {
            setShowMap(true);
            resolve(null);
          }
        }
      );
    });
  };


  const handleSubmit = async (formData) => {
    let coords = await fetchCoordinates(formData?.installationAddress, formData?.landmark, formData?.town);
    setFormData(formData)
    if (coords) {
      setCoordinates(coords);
    }
    if (coords) { validateMsisdn(formData.msisdn, formData.email, formData.name) }
    eventEmitter(AIRTEL_WORKS, `hbb_lead_form_proceed_clicked`, 'click', `hbb_lead_form_proceed_clicked`, null);
  }

  const validateMsisdn = (msisdn = formData.msisdn, email = formData.email, name = formData.name) => {
    if (!email) {
      return
    }
    let requestData = {
      msisdn: generateMsisdn(msisdn)
    };
    showLoader();
    getLineType(requestData)
      .then((res) => {
        res = res?.data;
        hideLoader();
        if (
          res?.status?.toLowerCase() == "success" ||
          res?.status?.toLowerCase() == 200
        ) {
          setIsAirtelNumber(true);
          sendOtp(msisdn, email, true, name);
          eventEmitter(AIRTEL_WORKS, 'te_validate_msisdn_success', 'click', 'te_validate_msisdn_success', null);

        } else {
          setIsAirtelNumber(false);
          sendOtp(msisdn, email, false, name);
          eventEmitter(AIRTEL_WORKS, 'te_validate_msisdn_success', 'click', res?.message, null);
        }
      })
      .catch((error) => {
        hideLoader();
        setIsAirtelNumber(false);
        sendOtp(msisdn, email, false, name);
        eventEmitter(AIRTEL_WORKS, 'te_validate_msisdn_failed', 'click', error?.error?.message, null);
      });
  };


  const showToastMsg = (type, message) => {
    setToastMsg({ type, message });
    setTimeout(() => setToastMsg(null), 10000);
  };

  const sendOtp = (msisdn = "", email, isAirtelNumber = false, name = formData.name) => {
    let postRequestData = {
      email,
      customerDetails: {
        fullName: name
      },
      requestType: selectedLanguage === EN ? AW_TRANSANCTION_TYPE : AW_TRANSANCTION_TYPE_SW
    };
    postRequestData = { ...postRequestData, ...(!isAirtelNumber ? {} : { msisdn: generateMsisdn(msisdn) }) };
    let postRequest = {
      data: postRequestData,
    };
    showLoader();
    getOtpV1(postRequest).then(
      (res) => {
        res = res?.data;
        hideLoader();
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          setShowOtpModal(true);
          setRefId(res?.result?.refId);
          checkServicability(formData?.town);
          eventEmitter(AIRTEL_WORKS, 'te_send_otp_success', 'click', 'te_send_otp_success', null);
        } else {
          if (res &&
            (res?.status == 502 || res?.statusCode == 502)) {
            handleLimitExhaust();
          }
          showToastMsg("Error", res?.message || "Something Went Wrong!");
          eventEmitter(AIRTEL_WORKS, 'te_send_otp_failed', 'click', res?.message, null);
        }
      },
      (error) => {
        hideLoader();
        showToastMsg(
          "Error",
          error?.error?.message || error?.message || "Something Went Wrong!"
        );
        eventEmitter(AIRTEL_WORKS, 'te_send_otp_failed', 'click', error?.error?.message, null);
      }
    );
  };


  const toggleModalEvent = () => {
    setShowOtpModal(false);
  };

  const checkServicability = useCallback((selectedTown) => {
    let hbbLeadFeasibility = towns.find(
      (town) =>
        town?.cityName?.toLowerCase() === selectedTown?.toLowerCase() &&
        town.hbbLeadFeasibility
    );
    return !!hbbLeadFeasibility;
  }, [towns]);


  const handleSelectedPlan = (bundle) => {
    setBundleData(bundle);
    setShowForm(true);
    eventEmitter(AIRTEL_WORKS, 'hbb_5g_plan_selected_proceed_clicked', 'click', bundle?.description, null);
  };

  const handleOtpVerified = (uniqueCode) => {
    setShowOtpModal(false);
    setIsOtpVerified(true);
    let leadId;
    let isFeasible = checkServicability(formData.town)
    if (isFeasible) {
      sessionStorage.setItem("queryData", JSON.stringify({
        ...bundleData, msisdn: generateMsisdn(formData?.msisdn),
        rechargeType: translation.oduPurchase,
        lineType: isAirtelNumber ? bundleData?.lineType : 'INVALID',
        emailId: formData?.email,
        redirectPage: redirectUrl,
        flow: "Airtel Works"
      }), true);
      setIsServiceable(true);

    } else {
      setIsServiceable(false);
    }
    let postData = {
      fullName: formData?.name,
      contactNumber: generateMsisdn(formData?.msisdn),
      email: formData?.email,
      feasibility: isFeasible,
      address: {
        type: INSTALLATION,
        landmark: formData.installationAddress,
        lat: coordinates?.lat,
        lng: coordinates?.lng,
        city: formData?.town,
        street1: formData.installationAddress,
        country: process.env.REACT_APP_COUNTRY
      },
      plan: {
        "code": bundleData?.productCode,
        "amount": bundleData?.amount,
        "currency": bundleData?.currency,
        "description": bundleData?.description
      },
      "source": WEBPORTAL,
      "uniqueCode": uniqueCode,
      lineType: PREPAID,
      consent: formData?.termsAndCondition,
      channelName: WEBSITE,
      utmTags: getSessionData('tags') || {}
    }

    submitLead(postData).then(res => {
      leadId = res?.data?.result?.refLeadId;
      if (isFeasible && leadId) {
        sessionStorage.setItem('airtelWorks', JSON.stringify({ isAirtelWorks: true, id: leadId }))
        setTimeout(() => {
          setHideServiceModal(true);
          navigate('/payment/start');
        }, 3000)
        eventEmitter(AIRTEL_WORKS, 'hbb_lead_successful_feas', 'click', 'hbb_lead_successful_feas', null);
      } else {
        if (isFeasible) {
          showToastMsg("Error", "Something Went Wrong!")
          setHideServiceModal(true);
        } else {
          setTimeout(() => {
            setHideServiceModal(true);
            goToDeviceList();
          }, 6000)
          eventEmitter(AIRTEL_WORKS, 'hbb_lead_successful_non_feas', 'click', 'hbb_lead_successful_non_feas', null);
        }
      }
    })

  }

  const handleLimitExhaust = () => {
    setisOtpLimitExhausted(true);
    setShowOtpModal(false);
    setCoordinates({})
  }


  const handleMapAddress = (value) => {
    let { lat, lng } = value;
    setCoordinates({ lat, lng });
    setShowMap(false);
    validateMsisdn()
  }

  const goToDeviceList = () => {
    navigate(redirectUrl);
    eventEmitter(AIRTEL_WORKS, 'hbb_lead_form_back_clicked', 'click', 'hbb_lead_form_back_clicked', null);
  };

  const proceedBtn = () => {
    setShowForm(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
    eventEmitter(AIRTEL_WORKS, 'hbb_5g_plan_selected_proceed_clicked', 'click', 'hbb_5g_plan_selected_proceed_clicked', null);
  }

  const cancelBtn = () => {
    navigate(redirectUrl);
    eventEmitter(AIRTEL_WORKS, 'hbb_5g_plan_selected_back_clicked', 'click', 'hbb_5g_plan_selected_back_clicked', null);
  }

  const getFeaturesByLanguage = () => {
    return selectedLanguage.toLowerCase() === EN ? deviceDetails?.features : deviceDetails?.featuressw;
  };

  return (
    <>
      <div className="odu-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="device-wrap">
                <div className="device-details">
                  <div className="device-img">
                    <img
                      src={deviceDetails?.heading_image}
                      alt={"deviceImg"}
                    ></img>
                  </div>
                  <h5>{deviceDetails?.deviceName}</h5>

                  <div className='scroll-item'>
                    <ul>
                      {(getFeaturesByLanguage() || []).map((element, index) => (
                        <li key={index}>{element}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                {!!Object.entries(bundleData).length && (
                  <div className="selected-plan">
                    <div className="selected-label">Selected Plan</div>
                    <div className="selected-card">
                      <h5>{bundleData?.description}</h5>
                      <p>
                        <strong>
                          {bundleData?.currency} {bundleData?.amount}{" "}
                        </strong>{" "}
                        <strong>
                          /{bundleData?.validity}
                          {bundleData?.validityUnit}
                        </strong>
                      </p>
                      <ul>
                        <li>
                          {bundleData?.data}
                          {bundleData?.dataUnit}
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-9">
              <div className="plan-details">
                {!showForm && (
                  <>
                    <h5>{translation.selectPlanText}</h5>
                    <span>{translation?.selectedPlanDescription}</span>
                    {isMobileDevice ? <HbbPlanList bundleList={bundles} translations={translation?.bundleTable} handleSelectedPlan={handleSelectedPlan} /> : <PlanTable
                      bundles={bundles}
                      translation={translation.bundleTable}
                      sendSelectedPlan={handleSelectedPlan}
                    />
                    }
                    {!!bundles?.length && translation.noteText && <p className="airtel-works-note"><strong className="red">{translation.note} </strong>{translation.noteText}</p>}
                  </>
                )}
                {showForm && (
                  <>
                    <h5>{translation.customerDetails}</h5>
                    <DynamicForm
                      formSchema={formSchema}
                      handleSubmit={handleSubmit}
                      clearFormData={clearFormData}
                      handleBack={goToDeviceList}
                    />
                  </>
                )}
                {/* {!showForm && (
                  <div className="button-wrap">
                    <a className="back-button" onClick={cancelBtn}>
                      <img
                        src="https://cdn-webportal.airtelstream.net/website/uganda/assets/images/icons/back-arrow.svg"
                        alt={""}
                      />
                      {translation.back}
                    </a>
                    <button
                      className="button proceed"
                      disabled={!Object.entries(bundleData).length}
                      onClick={proceedBtn}
                    >
                      {" "}
                      {translation.proceed}
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showOtpModal && (
        <>
          <AwOtpModal
            msisdn={formData.msisdn}
            email={formData.email}
            isAirtelNumber={isAirtelNumber}
            refId={refId}
            toggleModalEvent={toggleModalEvent}
            sendOtpVerifiedEvent={handleOtpVerified}
            maxLimitExaustEvent={handleLimitExhaust}
          />
        </>
      )}
      {isServiceable && !hideServiceModal && (
        <Modal isOpen={isOtpVerified}>
          <>
            <div className="success-modal">
              <img src="assets/icons/correct.svg" width='50px' alt="success" />
              <h3>{translation.congratulations}</h3>
              <p>{translation.serviceAvailableText}</p>
              <p style={{ fontSize: "14px" }}>{translation.redirectMsg}</p>
            </div>
          </>
        </Modal>
      )}
      {!isServiceable && !hideServiceModal && (
        <Modal isOpen={isOtpVerified}>
          <>
            <div className="thank-modal">
              <img src="assets/icons/correct.svg" width='50px' alt="success" />
              <h3>{translation.thankYou}</h3>
              <p>
                {translation.serviceUnavailableText}
              </p>
              <button className="button" onClick={goToDeviceList}>
                {translation.exploreProduct}
                <img src="assets/icons/right-arrow-white.svg" width='40px' alt="success" />
              </button>
            </div>
          </>
        </Modal>
      )}
      {showMap && coordinates?.lat && <MapPicker onContinue={handleMapAddress} coordinates={coordinates} />}
      {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}
      {showMap &&
        <MapPicker onContinue={handleMapAddress} />
      }
    </>

  );
};

export default OduLandingPage;
